class ContentBanner extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    window.loadSwiper.then((swiperLib) => {
      this.swiperLib = swiperLib;
      this._initCarousel();
    });
  }

  disconnectedCallback() {}

  _initCarousel() {
    const { Swiper, Pagination, Autoplay } = this.swiperLib;

    let autoplay = false;
    let delay = 0;

    if (this.hasAttribute("delay")) {
      delay = parseInt(this.getAttribute("delay"), 10);

      autoplay = {
        delay,
        disableOnInteraction: false,
      };
    }

    const swiperParams = {
      modules: [Pagination, Autoplay],
      slidesPerView: "auto",
      autoplay,
      speed: 300,
      loop: true,
      pagination: {
        el: this.querySelector(".swiper-pagination"),
        clickable: true,
        renderBullet: (index, className) => {
          return `<span class="${className}" aria-label="Go to slide ${index + 1}"></span>`;
        },
      },
      navigation: {
        nextEl: this.querySelector("[data-navigation-next]"),
        prevEl: this.querySelector("[data-navigation-previous]"),
      },
    };

    this.swiper = new Swiper(this, swiperParams);
    this.lastSlide = this.swiper.slides[this.swiper.activeIndex];

    this.swiper.on("slideChange", () => {
      this.lastSlide
        ?.querySelector("video-snippet")
        ?.dispatchEvent(new CustomEvent("video-snippet:pause"));

      const currentSlide = this.swiper.slides[this.swiper.activeIndex];

      currentSlide
        ?.querySelector("video-snippet")
        ?.dispatchEvent(new CustomEvent("video-snippet:play"));

      this.lastSlide = currentSlide;
      this._syncPaginationProgress(delay);
    });

    this.swiper.on("autoplayStart", () => {
      this._syncPaginationProgress(delay);
    });

    this.swiper.on("autoplayResume", () => {
      this._syncPaginationProgress(delay);
    });

    this._syncPaginationProgress(delay);
  }

  _syncPaginationProgress(delay) {
    if (!this.swiper) return;

    const bullets = this.swiper.pagination?.bullets || [];

    bullets.forEach((bullet) => {
      bullet.innerHTML = ""; // remove fill completely
    });

    if (!delay || !bullets.length) return;

    const activeBullet = bullets[this.swiper.realIndex];

    if (!activeBullet) return;

    const fill = document.createElement("span");
    fill.className = "content-banner__pip-fill";

    activeBullet.appendChild(fill);

    requestAnimationFrame(() => {
      fill.style.transition = `transform ${delay}ms linear`;
      fill.style.transform = "scaleX(1)";
    });
  }
}

if (!customElements.get("content-banner")) {
  customElements.define("content-banner", ContentBanner);
}